var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['custom', _vm.advanced.cssClasses, _vm.responsiveClasses],style:(_vm.style),attrs:{"id":_vm.advanced.cssId}},[_c('div',{staticClass:"custom-inner",class:'el-'+_vm.details.id,domProps:{"innerHTML":_vm._s(_vm.basic.html||'')}})])
}
var staticRenderFns = []

export { render, staticRenderFns }